/* AVMR2 — relais d'achat
   Aucun formulaire n'est créé ici. Tous les boutons marqués [data-avmr2-buy]
   déclenchent le bouton "Ajouter au panier" natif du thème (Shrine Pro),
   ce qui conserve le sélecteur de variantes, les paiements dynamiques,
   les applications de bundle et le tiroir panier du thème.            */
(function () {
  'use strict';

  var SELECTORS = [
    'product-form button[name="add"]',
    'form[action*="/cart/add"] button[name="add"]',
    'form[action*="/cart/add"] [type="submit"]'
  ];

  function nativeButton() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      if (el && !el.closest('[data-avmr2-buy]')) return el;
    }
    return null;
  }

  function scrollToBuy(btn) {
    var target = btn.closest('product-form') || btn.closest('form') || btn;
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-avmr2-buy]');
    if (!trigger) return;
    e.preventDefault();

    var btn = nativeButton();

    /* Pas de bouton natif trouvé : on renvoie vers la fiche produit. */
    if (!btn) {
      var url = trigger.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }

    /* Variante indisponible : on remonte à la zone d'achat plutôt que d'échouer en silence. */
    if (btn.disabled) {
      scrollToBuy(btn);
      return;
    }

    if (trigger.getAttribute('data-avmr2-buy') === 'scroll') {
      scrollToBuy(btn);
      return;
    }

    btn.click();
  });
})();
